import { render, staticRenderFns } from "./EventItemPicker.vue?vue&type=template&id=63e732f6"
import script from "./EventItemPicker.vue?vue&type=script&lang=js"
export * from "./EventItemPicker.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports